module.exports = " <h2 class=text-center>Tu cuenta se esta verificando</h2> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Verify-account.vue
// module id = 588
// module chunks = 0